import { state } from "../../state.js";
import { getSetting } from "../../settings.js";
import { createTab } from "../../dom/layout.js";

function appendLabelValue(container, labelText, valueId, { labelClass, initial = "-" } = {}) {
  const label = document.createElement("p");
  label.textContent = labelText;
  if (labelClass) label.className = labelClass;
  container.append(label);

  const value = document.createElement("p");
  value.id = valueId;
  value.textContent = initial;
  container.append(value);
}

// Race and training share an identical event header: Event / Race / Session.
export function createEventCommon(eventDiv) {
  appendLabelValue(eventDiv, "Event: ", "eventName");
  appendLabelValue(eventDiv, "Race: ", "currentRace", { labelClass: "descLabel" });
  appendLabelValue(eventDiv, "Session: ", "currentSession", { labelClass: "descLabel" });
}

export function setEventCommon(data) {
  document.getElementById("eventName").innerHTML = data.EventName;
  document.getElementById("currentRace").innerHTML = data.RaceName;
  document.getElementById("currentSession").innerHTML = data.SessionName;
}

// Race and training share an identical "fastest lap" session readout.
export function createFastestLapSessionData(sessionDiv) {
  const fastest = document.createElement("p");
  fastest.textContent = "Fastest Lap: ";
  sessionDiv.append(fastest);

  const name = document.createElement("p");
  name.id = "fastesLapName";
  name.textContent = "Name";
  sessionDiv.append(name);

  const time = document.createElement("p");
  time.id = "fastesLapTime";
  time.textContent = "0.0";
  time.className = "smallSpace";
  sessionDiv.append(time);

  const inLap = document.createElement("p");
  inLap.textContent = "in Lap: ";
  inLap.className = "smallSpace";
  sessionDiv.append(inLap);

  const at = document.createElement("p");
  at.id = "fastesLapAt";
  at.textContent = "0";
  sessionDiv.append(at);
}

export function setFastestLapSession(data) {
  if (data.hasOwnProperty("FastesLapStn")) {
    document.getElementById("fastesLapName").innerHTML = " #" + data.FastesLapStn + " " + data.FastesLapBy;
    document.getElementById("fastesLapTime").innerHTML = data.FastesLapTime;
    document.getElementById("fastesLapAt").innerHTML = data.FastesLapAt;
  } else {
    document.getElementById("fastesLapName").innerHTML = " -";
    document.getElementById("fastesLapTime").innerHTML = "-";
    document.getElementById("fastesLapAt").innerHTML = "-";
  }
}

// Race and training build their ranking tabs identically (class-tabs toggle
// from settings, one table per class plus an "ALL" tab).
export function createRankingCommon(rankingdiv, data) {
  state.tableIdentifires = [];
  if (getSetting("showClassTabs")) {
    const tab = document.createElement("div");
    tab.className = "tab";
    rankingdiv.append(tab);
    createTab(rankingdiv, tab, "", data.Classes, "ALL", "Ranking", "All", true, true);
    for (let i = 0; i < data.Classes.length; i++) {
      createTab(rankingdiv, tab, data.Classes[i], [data.Classes[i]], data.Classes[i], "Ranking", "Class");
    }
  } else {
    const tbl = document.createElement("table");
    tbl.id = "tblRanking";
    rankingdiv.append(tbl);
    state.tableIdentifires.push({
      Classes: data.Classes,
      tableId: tbl.id,
      Ranking: "Ranking",
      Identifire: "",
      RankingType: "Ranking",
    });
  }
}
